import { IOrganization } from 'common/src/types/interfaces';

import OrganizationForm from 'portal/src/components/systemAdministration/Form/Organization/OrganizationForm';
import { FormComponentType } from 'portal/src/layouts/base/FormComponentType';

const SystemAdministrationOrganizationForm: FormComponentType = ({
  entity,
  handleBackAction,
}: {
  entity?: IOrganization;
  handleBackAction: () => void;
}) => (
  <OrganizationForm
    entity={entity}
    isSysAdminView={true}
    handleBackAction={handleBackAction}
  />
);

export default SystemAdministrationOrganizationForm;
